<template>
<section class="termsBox">

    <h2 class="conTit1 mgt1">양도 시 주의사항</h2>

    <div class="termsCon" id="termsPart2">
        <ol class="circleNum">
            <li>1. 양수인의 서비스 이용 가능 기간은 <span class="textDecorationUnderline">최초가입자의 서비스 이용기간과 동일합니다.</span></li>
            <li>2. 양수인은 양도 받은 멤버십에 대해서는 <span class="textDecorationUnderline">환불이 불가합니다</span></li>
            <li>3. 가입기간의 잔여 서비스 기간이 30일 이상이어야만 양도 가능하며, <span class="textDecorationUnderline">양수 받은 고객은 (양수인)해지 시 환불이 불가합니다.</span></li>
        </ol>
    </div>

</section>
</template>

<script>
export default {
    name: 'TermEscalation'
}
</script>

<style lang="scss" scoped>
.textDecorationUnderline {
    text-decoration:underline;
}
</style>